// The question payloads every screen reads: what students may see of a
// question, and the results a question ends with. Pure functions of their
// inputs, shared by the backend that sends them and the host screen that
// builds its own view before the first QUESTION_START arrives.
// A QUESTION_START's time limit in milliseconds. Servers before
// timeLimitMs sent only `timeLimit`, and a screen can meet one while a
// deploy is in progress; this is the one place that knows the old name.
// Remove it with QUESTION_START's timeLimit in the release after next:
// the Release after the one that first sends timeLimitMs.
export function questionTimeLimitMs(start) {
    return start.timeLimitMs ?? start.timeLimit;
}
// What students may see of a question: everything but isCorrect.
export function toPublicQuestion(q) {
    return {
        qid: q.qid,
        type: q.type,
        level: q.level,
        text: q.text,
        pictureUrl: q.pictureUrl,
        options: q.options.map((o) => ({ oid: o.oid, text: o.text })),
    };
}
// The QUESTION_END payload for a question, from its answers and the
// current ranked roster: the option tally, the correct options, and the
// full ranked leaderboard with each student's points for this question.
export function buildQuestionEnd(questionIndex, question, answers, topEntries) {
    const correctOids = question.options
        .filter((o) => o.isCorrect)
        .map((o) => o.oid);
    const tally = new Map();
    for (const ans of answers) {
        for (const oid of ans.answerOids) {
            tally.set(oid, (tally.get(oid) ?? 0) + 1);
        }
    }
    for (const opt of question.options) {
        if (!tally.has(opt.oid))
            tally.set(opt.oid, 0);
    }
    const results = Array.from(tally.entries()).map(([oid, count]) => ({
        oid,
        count,
    }));
    const deltaByName = new Map();
    for (const ans of answers) {
        deltaByName.set(ans.displayName, (deltaByName.get(ans.displayName) ?? 0) + ans.pointsAwarded);
    }
    const leaderboard = topEntries.map((e) => ({
        displayName: e.displayName,
        score: e.score,
        delta: deltaByName.get(e.displayName) ?? 0,
    }));
    return {
        type: "QUESTION_END",
        questionIndex,
        correctOids,
        results,
        leaderboard,
    };
}
//# sourceMappingURL=questionPayloads.js.map